import { array, defineAction, dateTime, object, string } from '~/prix'
import action from './legalEntityFetchLogs.action.json'

const legalEntityFetchLogsDefinition = defineAction({
  ...action,
  input: object({
    legalEntityId: string().label('ID da empresa'),
    legalEntityCnpj: string().isOptional().label('CNPJ da empresa'),
  }),
  output: object({
    items: array(
      object({
        id: string(),
        actionKey: string(),
        userId: string(),
        timestamp: dateTime(),
        requestId: string(),
      }),
    ),
  }),
})

export default legalEntityFetchLogsDefinition
